/*
 * @Author: achuang
 * @Date: 2024-09-05 16:47:59
 * @LastEditTime: 2024-09-13 09:34:04
 * @LastEditors: achuang
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "tailwindcss/tailwind.css";

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
